import { useEffect, useMemo, useRef } from 'react';
import styled from '@emotion/styled';

import QrImage from './components/QrImage';
import Caption from './components/Caption/Caption';
import HowToPayHeader from './components/HowToPayHeader';
import HowToPayList from './components/HowToPayList';
import DownloadButton from './components/DownloadButton/DownloadButton';
import CaptionLoad from './components/Caption/CaptionLoad';
import { useParamsAccountId } from '../Accounts/utils/useParamsAccountId';
import { getAccountName } from './utils/getAccountName';
import { trackOpen } from './utils/analytics';
import type { QRRepayment } from 'src/types/generated/pos';
import { MappedAccountObject } from '@api/mappers/accountMapper';

const Container = styled.div`
	padding: 0 16px;
	position: relative;
`;

interface QrRepaymentProps {
	accounts: MappedAccountObject;
	qrData: QRRepayment;
	providerCode: string;
	userName: string;
}

export type AccountParams = {
	accountId: number;
	accounts: MappedAccountObject;
};

const QrRepaymentComponent = (props: QrRepaymentProps) => {
	const { accounts, qrData, providerCode, userName } = props;
	const accountId = useParamsAccountId();

	const ref = useRef<HTMLDivElement>(null);

	const productName = useMemo(() => {
		return getAccountName({ accountId, accounts });
	}, [accounts, accountId]);

	useEffect(() => {
		trackOpen({ accountId, accounts });
	}, []);

	return (
		<Container>
			<div ref={ref}>
				<QrImage src={qrData.qrUrl} />

				{productName ? (
					<Caption
						userName={userName}
						productName={productName}
						isLoading={false}
						expirationDate={qrData.expirationTime}
					/>
				) : (
					<CaptionLoad />
				)}

				<HowToPayHeader />
				<HowToPayList providerCode={providerCode} />
			</div>

			<DownloadButton isLoading={false} parentRef={ref} />
		</Container>
	);
};

export default QrRepaymentComponent;
